import React, { Component } from 'react';
import PropTypes from 'prop-types';
import observeRootStore from '../../../components/hoc/observeRootStore';

class FilterOptionInput extends Component {
    handleOptionChange = e => {
        this.props.rootStore.uiStore.selectedFilter = e.target.value;
    };

    render() {
        return (
            <div className="form-check">
                <label>
                    <input
                        type="radio"
                        name="map-filter"
                        value={this.props.optionValue}
                        checked={
                            this.props.rootStore.uiStore.selectedFilter ===
                            this.props.optionValue
                        }
                        onChange={this.handleOptionChange}
                        className="form-check-input"
                    />
                    <span className='radio'></span>
                    {this.props.label}
                </label>
            </div>
        );
    }
}

FilterOptionInput.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedFilter: PropTypes.string
        })
    }).isRequired,
    optionValue: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired
};

export default observeRootStore(FilterOptionInput);
